import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

const storageKey = 'velora-cart-countdown';
let deadline = 0;

function readDeadline() {
  if (deadline) return deadline;
  try { deadline = Number(sessionStorage.getItem(storageKey)); } catch {}
  if (!deadline) {
    deadline = Date.now() + 5 * 60 * 1000;
    try { sessionStorage.setItem(storageKey, String(deadline)); } catch {}
  }
  return deadline;
}

/** A five-minute cart timer; it neither reserves stock nor deletes cart contents. */
class CartCountdown extends Component {
  requiredRefs = ['minutes', 'seconds'];
  #interval;

  connectedCallback() {
    super.connectedCallback();
    clearInterval(this.#interval);
    this.#update();
    this.#interval = setInterval(() => this.#update(), 1000);
  }

  updatedCallback() {
    super.updatedCallback();
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.#interval);
  }

  #update() {
    const remaining = Math.max(0, Math.ceil((readDeadline() - Date.now()) / 1000));
    this.refs.minutes.textContent = String(Math.floor(remaining / 60)).padStart(2, '0');
    this.refs.seconds.textContent = String(remaining % 60).padStart(2, '0');
    this.hidden = false;
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ detail }) => {
    if (detail?.items?.length !== 0) return;
    deadline = 0;
    try { sessionStorage.removeItem(storageKey); } catch {}
  }).catch(() => {});
});

if (!customElements.get('vd-cart-countdown')) customElements.define('vd-cart-countdown', CartCountdown);
